import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook, Linkedin, ArrowRight } from "lucide-react";
import { useContent } from "../../lib/content";
import { Button } from "../ui/button";

const COL_LINKS = [
  ["Explore", [["About", "/about"], ["Programs", "/programs"], ["Impact", "/impact"], ["Gallery", "/gallery"]]],
  ["Get involved", [["Volunteer", "/volunteer"], ["Partners", "/partners"], ["Contact", "/contact"], ["FAQ", "/faq"]]],
  ["Legal", [["Privacy Policy", "/privacy"], ["Terms of Use", "/terms"]]],
];

export const Footer = () => {
  const { content } = useContent();

  return (
    <footer data-testid="site-footer" className="mt-32 relative bg-gradient-to-b from-white to-accent/35">
      <div className="h-px bg-gradient-to-r from-transparent via-sky/40 to-transparent" aria-hidden />
      <div className="container-tt py-16 md:py-20 grid gap-12 md:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-2 space-y-5">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full btn-sky-fill text-white font-display shadow-sky ring-1 ring-white/40">Tt</span>
            <span className="font-display text-2xl text-stone">{content.brand.name}</span>
          </div>
          <p className="text-muted-foreground max-w-sm">{content.brand.tagline}</p>
          <div className="card-surface p-6 max-w-md" data-testid="footer-contact-cta">
            <div className="font-display text-xl text-stone">Get in contact with us</div>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">Questions, partnership ideas, or a senior center we should visit? We'd love to hear from you.</p>
            <div className="mt-5 flex flex-wrap gap-2">
              <Button asChild className="btn-pill btn-motion btn-sky-fill text-white h-11 px-5 shadow-sky hover:shadow-skyHover border-0">
                <Link to="/contact" data-testid="footer-contact-btn">Contact us <ArrowRight size={16} className="ml-1" /></Link>
              </Button>
              <a href={`mailto:${content.brand.email}`} className="btn-pill btn-motion inline-flex items-center gap-2 h-11 px-5 border border-border bg-white text-stone hover:border-sky/60 hover:text-skyDark transition-colors">
                <Mail size={16} /> Email
              </a>
            </div>
          </div>
        </div>

        {COL_LINKS.map(([title, links]) => (
          <div key={title}>
            <div className="eyebrow mb-5">{title}</div>
            <ul className="space-y-3">
              {links.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="link-underline text-stone/85 hover:text-skyDark transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="container-tt pb-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-border/70 pt-6">
        <div className="text-sm text-muted-foreground">© {new Date().getFullYear()} {content.brand.name}. Made with care in {content.brand.location}.</div>
        <div className="flex items-center gap-3">
          <a href={`mailto:${content.brand.email}`} aria-label="Email" className="h-10 w-10 rounded-full bg-white border border-border grid place-items-center text-stone/70 hover:bg-sky hover:border-sky hover:text-white transition-colors"><Mail size={16} /></a>
          <a href={content.socials?.instagram || "#"} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full bg-white border border-border grid place-items-center text-stone/70 hover:bg-sky hover:border-sky hover:text-white transition-colors"><Instagram size={16} /></a>
          <a href={content.socials?.facebook || "#"} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-10 w-10 rounded-full bg-white border border-border grid place-items-center text-stone/70 hover:bg-sky hover:border-sky hover:text-white transition-colors"><Facebook size={16} /></a>
          <a href={content.socials?.linkedin || "#"} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="h-10 w-10 rounded-full bg-white border border-border grid place-items-center text-stone/70 hover:bg-sky hover:border-sky hover:text-white transition-colors"><Linkedin size={16} /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
